import { useLocalization } from '@shared-ui/localization-context';
import * as React from 'react';
import { UitkIcon } from 'uitk-react-icons';
import { classNames, analyticsTracker, liveAnnounce, Level } from 'uitk-react-utils';
import styles from './uitk-pill.css';

var _this = undefined;
var getClassNameList = classNames.bind(styles);
var UitkRemovablePill = function (props) {
    var _a;
    var active = props.active, a11yRemoveText = props.a11yRemoveText, altText = props.altText, analytics = props.analytics, children = props.children, className = props.className, disabled = props.disabled, icon = props.icon, id = props.id, name = props.name, onClick = props.onClick, buttonRef = props.buttonRef, value = props.value;
    var baseClassName = 'uitk-pill';
    var l10n = useLocalization();
    var handleClick = function (evt) {
        if (a11yRemoveText) {
            liveAnnounce(a11yRemoveText, Level.POLITE);
        }
        onClick(evt);
    };
    var wrapperClassName = getClassNameList("".concat(baseClassName, " ").concat(baseClassName, "-removable ").concat(baseClassName, "-content"), className, (_a = {},
        _a["".concat(baseClassName, "-disabled")] = disabled,
        _a["".concat(baseClassName, "-active")] = active,
        _a));
    var ariaLabel = '';
    if (altText) {
        ariaLabel = altText;
    }
    else {
        ariaLabel = "".concat(l10n.formatText('remove'), " ").concat(children);
    }
    return (React.createElement("button", { id: id, name: name, onClick: handleClick, onClickCapture: analytics && analyticsTracker.bind(_this, analytics), className: wrapperClassName, type: "button", disabled: disabled, "aria-label": ariaLabel, ref: buttonRef, value: value },
        icon && React.createElement(UitkIcon, { className: getClassNameList("".concat(baseClassName, "-icon")), name: icon }),
        React.createElement("span", { className: getClassNameList("".concat(baseClassName, "-text")) }, children),
        React.createElement(UitkIcon, { className: getClassNameList("".concat(baseClassName, "-action-icon")), name: "close" })));
};
UitkRemovablePill.displayName = 'UitkRemovablePill';

export { UitkRemovablePill };
